export enum Rol {
  Citizen = 'Ciudadano',
  Validator = 'Funcionario',
  Coordinator = 'Coordinador',
  Director = 'Subdirector'

}
